<template>
  <form class="conversations-drop-zone"
        ref="fileform"
        v-show="value">

    <input type="file"
           style="display: none"
           ref="fileInput"
           :accept="accepted"
           @change="onFilePicked"
           :multiple="multipleImages">

    <div class="conversations-drop-zone__border">
      <v-carousel v-if="files.length > 0 && isImage">
        <v-carousel-item
          v-for="(item, i) in imagesRefs"
          :key="i"
          :src="imagesRefs[i]"
          reverse-transition="fade-transition"
          transition="fade-transition">
        </v-carousel-item>
      </v-carousel>
      <div v-if="files.length === 0">
        <div class="mb-2" style="text-align: center">

          <div class="drop-zone-button mx-2"
               @click="openExplorer('image')">
            <v-icon color="white"
                    class="kbBlue"
                    style="padding: 10px; border-radius: 50%; min-height: 32px; min-width: 32px">
              mdi-image
            </v-icon>

            <span class="py-2">Imagen</span>
          </div>
          <div class="drop-zone-button mx-2"
               @click="openExplorer('pdf')">
            <v-icon color="white"
                    class="kbBlue"
                    style="padding: 10px; border-radius: 50%; min-height: 32px; min-width: 32px">
              mdi-file-pdf-outline
            </v-icon>

            <span class="py-2">Pdf</span>
          </div>
          <div class="drop-zone-button mx-4"
               @click="openExplorer('video')">
            <v-icon color="white"
                    class="kbBlue"
                    style="padding: 10px; border-radius: 50%; min-height: 32px; min-width: 32px">
              mdi-file-video-outline
            </v-icon>

            <span class="py-2">Video</span>
          </div>
        </div>
        <div class="hidden-sm-and-down" style="text-align: center; padding: 0 10px 10px 10px">{{$t('general.clickOnYourFileTypeOrDragHere')}}</div>
      </div>

      <div v-else-if="!isImage" style="word-break: break-word; text-align: center; padding: 20px">
        {{files[0].name}}
      </div>

      <div style="display: flex;">
        <div class="send-button"
             @click="upload()"
             v-if="files.length > 0 && !uploadingFile">
          Enviar
        </div>

        <div class="cancel-button"
             @click="cancel()"
             v-if="!uploadingFile">
          Cancelar
        </div>
      </div>

      <div class="drop-zone-progress" v-if="uploadingFile">
        <div class="drop-zone-progress__value">
          {{uploadProgress}}% Completado
        </div>

        <div class="drop-zone-progress__successful"
             :style="{width: `${uploadProgress}%`}">
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import notifications from '@/libs/notifications'
export default {
  computed: {
    isImage () {
      if (this.files.length === 0) return false
      return /\.(jpe?g|png)$/i.test(this.files[0].name)
    }
  },
  data: () => ({
    accepted: '',
    dragAndDropCapable: false,
    multipleImages: false
  }),
  methods: {
    cancel () {
      this.$refs.fileInput.value = ''
      this.$emit('clear')
      this.$emit('input', false)
    },
    // Determines if the drag and drop functionality is in thewindow
    determineDragAndDropCapable () {
      // Create a test element to see if certain events are present that let us do drag and drop.
      const div = document.createElement('div')
      // Check to see if the `draggable` event is in the element
      // or the `ondragstart` and `ondrop` events are in the element. If
      // they are, then we have what we need for dragging and dropping files.
      // We also check to see if the window has `FormData` and `FileReader` objects
      // present so we can do our AJAX uploading
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
    },
    getImagePreview () {
      if (this.isImage) {
        for (let i = 0; i < this.files.length; i++) {
          const file = this.files[i]
          const picReader = new FileReader()
          picReader.addEventListener('load', () => {
            this.imagesRefs.push(picReader.result)
          })

          picReader.readAsDataURL(file)
        }
      }
    },
    onFilePicked (event) {
      const files = event.target.files
      if (files.length > 10) {
        notifications.error('No puedes enviar más de 10 Imagenes')
        this.cancel()
        return
      }
      for (let i = 0; i < files.length; i++) {
        if (this.longFile(files[i])) {
          notifications.error(this.$t('general.filesSize'))
          return
        }
      }
      this.$emit('filePicked', files)
      this.getImagePreview()
    },
    longFile (file) {
      let limit
      if (file.type === 'video/mp4') limit = 16777216
      else limit = 5242880
      if (file.size > limit) {
        return true
      }
      return false
    },
    openExplorer (type) {
      if (type === 'image') {
        this.accepted = '.png,.jpg,.jpeg'
        this.multipleImages = true
      }
      if (type === 'pdf') {
        this.accepted = '.pdf'
      }
      if (type === 'video') {
        this.accepted = '.mp4'
      }

      this.$nextTick(() => {
        this.$refs.fileInput.click()
      })
    },
    upload () {
      this.$emit('upload')
    }
  },
  mounted () {
    // Determine if drag and drop functionality is capable in the browser
    this.dragAndDropCapable = this.determineDragAndDropCapable()

    // If drag and drop capable, then we continue to bind events to our elements.
    if (this.dragAndDropCapable) {
      // Listen to all of the drag events and bind an event listener to each for the fileform.
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(evt => {
        // For each event add an event listener that prevents the default action
        // (opening the file in the browser) and stop the propagation of the event (so
        // no other elements open the file in the browser)
        this.$refs.fileform.addEventListener(evt, e => {
          e.preventDefault()
          e.stopPropagation()
        })
      })

      // Add an event listener for drop to the form
      this.$refs.fileform.addEventListener('drop', e => {
        // Capture the files from the drop event and add them to our local files array.
        const files = e.dataTransfer.files
        if (files.length > 10) {
          notifications.error('No puedes enviar más de 10 Imagenes')
          this.cancel()
          return
        }
        for (let i = 0; i < files.length; i++) {
          if (this.longFile(files[i])) {
            notifications.error(this.$t('general.filesSize'))
            return
          }
        }
        this.$emit('filePicked', files)
        this.getImagePreview()
      })

      window.addEventListener('dragover', e => {
        e.preventDefault()
        e.stopPropagation()
        if (this.enabled) this.$emit('input', true)
      })

      window.addEventListener('drop', e => {
        e.preventDefault()
        e.stopPropagation()
        this.$emit('input', false)
      })
    }
  },
  props: ['enabled', 'files', 'uploadingFile', 'uploadProgress', 'value', 'imagesRefs']
}
</script>

<style lang="scss">
  .cancel-button {
    background-color: #F44336;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    font-size: 14px;
    margin-top: 8px;
    min-width: 81px;
    padding: 8px;
    text-align: center;
  }

  .conversations-drop-zone {
    background-color: rgba(255, 255, 255);
    height: 100%;
    padding: 20px;
    position: absolute;
    width: 100%;
  }

  .conversations-drop-zone__border {
    align-items: center;
    border: dashed 3px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    font-size: 16px;
    height: 100%;
    justify-content: center;
  }

  .drop-zone-preview {
    border-radius: 8px;
    max-height: 65%;
    max-width: 90%;
  }

  .drop-zone-progress {
    background-color: grey;
    border-radius: 30px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin: 10px;
    position: relative;
    width: 90%;
    overflow: hidden;
  }

  .drop-zone-button {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .drop-zone-progress__successful {
    background-color: #4f8e62;
    border-radius: 30px;
    height: 30px;
    transition: width 0.5s ease;
  }

  .drop-zone-progress__value {
    color: white;
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    text-align: center;
    width: 100%;
  }

  .send-button {
    background-color: #4f8e62;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    font-size: 14px;
    margin-top: 8px;
    margin-right: 8px;
    min-width: 81px;
    padding: 8px;
    text-align: center;
  }
  .fa-chevron-right {
    font-size: 20px !important;
  }
  .fa-chevron-left {
    font-size: 20px !important;
  }
</style>
